import { Card, CardBody } from "@/components/ui";
import type { ReactNode } from "react";

interface StatCardProps {
  label: string;
  children: ReactNode;
  className?: string;
}

export function StatCard({ label, children, className }: StatCardProps) {
  return (
    <Card className={className}>
      <CardBody className="p-4">
        <p className="text-xs font-medium uppercase tracking-wide text-[var(--color-text-muted)]">
          {label}
        </p>
        <div className="mt-1 text-[var(--color-text)]">{children}</div>
      </CardBody>
    </Card>
  );
}
